import { WEEK_DAYS } from "components/ui/WeekDayCircles";

/**
 * The API returns times as a LocalTime object ({ hour, minute }) but accepts
 * and echoes back plain "HH:MM" strings, so both shapes turn up in a list.
 */
export const toTimeValue = (time) => {
  if (!time) return "";
  if (typeof time === "string") return time.slice(0, 5);

  const hour = String(time.hour ?? 0).padStart(2, "0");
  const minute = String(time.minute ?? 0).padStart(2, "0");

  return `${hour}:${minute}`;
};

/** ISO (yyyy-MM-dd) to the DD/MM/YYYY the practice reads dates in. */
export const toDisplayDate = (isoDate) => {
  if (!isoDate) return "-";

  const [year, month, day] = String(isoDate).split("T")[0].split("-");
  if (!year || !month || !day) return isoDate;

  return `${day}/${month}/${year}`;
};

/** The day ids a record has ticked, in Monday-first order. */
export const selectedDayIds = (record) =>
  WEEK_DAYS.filter((day) => record?.[day.id]).map((day) => day.id);

export const formatStaffName = (staff) => {
  if (!staff) return "-";

  const name = `${staff.firstName ?? ""} ${staff.lastName ?? ""}`.trim();

  return name || "-";
};

export const staffOptionLabel = (staff) => {
  const role = staff.staffRole ? ` (${staff.staffRole.toLowerCase()})` : "";

  return `${staff.active ? "✅ " : ""}${formatStaffName(staff)}${role}`;
};
